import { matchPath, useLocation } from "react-router-dom";

import { ROUTES } from "../../routes";
import {
  useGetInvoicePublicQuery,
  useGetInvoiceQuery,
} from "../../store/services/invoices";

export const useGetInvoiceDetails = (id: string) => {
  const location = useLocation();

  const isOnPublicView = !!matchPath(
    { path: ROUTES.INVOICE_BUSSINES_VIEW, end: true },
    location.pathname
  );

  const { data: invoice } = useGetInvoiceQuery(
    { id },
    { skip: !id || isOnPublicView }
  );

  const { data: publicInvoice } = useGetInvoicePublicQuery(
    { id },
    { skip: !id || !isOnPublicView }
  );

  return invoice || publicInvoice;
};
